export const cardRoutes = {
  app: {
    createCard: '/app/cards',
    deleteCard: `/app/cards/:id`,
    createSetupIntent: '/app/cards/create-setup-intent',
    getCardsList: `/app/cards`,
    updateCard: `/app/cards/:id`,
  },
};
